/* eslint-disable react/prop-types */
import React from 'react';
import { Form } from 'react-bootstrap';
import { BsInfoCircleFill } from 'react-icons/bs';

export const FormLabel = ({ label, required, info_key }) => (
  <Form.Label>
    {label}
    {required && <span className="text-danger ms-1">*</span>}
    {info_key && (
      <span
        style={{
          marginLeft: '5px',
          cursor: 'pointer',
          position: 'relative',
          display: 'inline-block'
        }}
        title={info_key}
      >
        <BsInfoCircleFill size={18} />
      </span>
    )}
  </Form.Label>
);
